import * as React from "react";
import { Component } from "react";
import { IExtendedAnnualSummaryByMonthRowProps } from "./interfaces";

export default class ExtendedAnnualSummaryByMonthRow extends Component<
  IExtendedAnnualSummaryByMonthRowProps
> {
  public constructor(props: IExtendedAnnualSummaryByMonthRowProps) {
    super(props);
  }

  public render() {
    const { annualSummaryRow } = this.props;
    return (
      <tr key={annualSummaryRow.id}>
        <td style={{ textAlign: "center" }}>
          {new Date(annualSummaryRow.statementDate).toISOString().substring(0, 10)}
        </td>
        <td style={{ textAlign: "center" }}>
          {new Date(annualSummaryRow.serviceStart).toISOString().substring(0, 10)}
        </td>
        <td style={{ textAlign: "center" }}>
          {new Date(annualSummaryRow.serviceEnd).toISOString().substring(0, 10)}
        </td>
        <td style={{ textAlign: "center" }}>{annualSummaryRow.numberOfDays}</td>
        <td style={{ textAlign: "right" }}>{annualSummaryRow.totalDelivered}</td>
        <td style={{ textAlign: "right" }}>{annualSummaryRow.onPeakFromGrid}</td>
        <td style={{ textAlign: "right" }}>{annualSummaryRow.offPeakFromGrid}</td>
        <td style={{ textAlign: "right" }}>{annualSummaryRow.totalSolarGenerated}</td>
        <td style={{ textAlign: "right" }}>{annualSummaryRow.onPeakGenerated}</td>
        <td style={{ textAlign: "right" }}>{annualSummaryRow.offPeakGenerated}</td>
        <td style={{ textAlign: "right" }}>{annualSummaryRow.lastMonthOnPeakCredits}</td>
        <td style={{ textAlign: "right" }}>{annualSummaryRow.lastMonthOffPeakCredits}</td>
        <td style={{ textAlign: "right" }}>
          {annualSummaryRow.netOffPeakElectricity > 0 ? annualSummaryRow.netOffPeakElectricity : 0}
        </td>
        <td style={{ textAlign: "right" }}>
          {annualSummaryRow.netOnPeakElectricity > 0 ? annualSummaryRow.netOnPeakElectricity : 0}
        </td>
        <td style={{ textAlign: "right" }}>
          {annualSummaryRow.netElectricity > 0 ? annualSummaryRow.netElectricity : 0}
        </td>
        <td style={{ textAlign: "right" }}>{annualSummaryRow.netGridUsage}</td>
        <td style={{ textAlign: "right" }}>{annualSummaryRow.solarDirectlyUsed}</td>
        <td style={{ textAlign: "right" }}>{annualSummaryRow.totalHouseholdUsage}</td>
        <td style={{ textAlign: "right" }}>{annualSummaryRow.percentSolarGenerated.toFixed(2)}%</td>
        <td style={{ textAlign: "right" }}>${annualSummaryRow.electricBillAmount.toFixed(2)}</td>
      </tr>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/projects/project/reports/extendedannualsummary/ExtendedAnnualSummaryByMonthRow.tsx